import {
  isRequestWizardFieldDecimalType,
  isRequestWizardFieldEmailType,
  isRequestWizardFieldFileType,
  isRequestWizardFieldPhoneType,
  isRequestWizardFieldStringType,
  isRequestWizardFieldTextType,
} from '../../../RequestWizardForm.utils'
import { Divider } from '../Divider'

import { FileInput } from './FileInput'
import { Input } from './Input'
import { PhoneInput } from './PhoneInput'
import { TextInput } from './TextInput'

import * as styles from './Variable.module.css'

function Variable({ card, filesOptions, hasDivider }) {
  return (
    <>
      {hasDivider ? <Divider /> : null}
      {isRequestWizardFieldStringType(card.variable_type) ||
      isRequestWizardFieldDecimalType(card.variable_type) ||
      isRequestWizardFieldEmailType(card.variable_type) ? (
        <Input card={card} fieldClassName={styles.field} />
      ) : null}
      {isRequestWizardFieldPhoneType(card.variable_type) ? (
        <PhoneInput card={card} fieldClassName={styles.field} />
      ) : null}
      {isRequestWizardFieldTextType(card.variable_type) ? (
        <TextInput card={card} fieldClassName={styles.field} />
      ) : null}
      {isRequestWizardFieldFileType(card.variable_type) ? (
        <FileInput
          card={card}
          fieldClassName={styles.field}
          filesOptions={filesOptions}
        />
      ) : null}
    </>
  )
}

export { Variable }
